type AllowedFieldTypes = string | number;
type AllowedFieldArrayTypes = string[];

export function convertFieldsToStrings(obj: Record<string, AllowedFieldTypes>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, typeof value === 'number' ? String(value) : value]),
  );
}

export function convertFieldsToStringArrays(obj: Record<string, AllowedFieldArrayTypes>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : String(value)]),
  );
}
